<template>
    <form class="forget-form" v-on:submit.prevent="restore">
        <h3>{{ $t('Reset Password') }}</h3>
        <b-alert v-if="resetComplete" dismissible fade variant="success" show>{{ $t('Thank you, your password was successfully changed.') }}</b-alert>
        <p>{{ $t('Please enter new password for your account.') }}</p>
        <div :class="{ 'has-error' : errors.has('formReset.pass') }" class="input-wrapper form-group">
            <label class="control-label">{{ $t('Password') }} <span>*</span></label>
            <input v-model.trim="formReset.pass" v-validate="'required|min:6'" name="formReset.pass" class="form-control placeholder-no-fix" type="password" maxlength="100" autocomplete="off" ref="formReset.pass">
            <span v-show="errors.has('formReset.pass')" id="reset-pass-tooltip" class="help-block alt"><span class="error-sign"></span></span>
            <b-tooltip ref="tooltip-reset-pass" target="reset-pass-tooltip" placement="top" >{{errors.first('formReset.pass')}}</b-tooltip>
        </div>
        <div :class="{ 'has-error' : errors.has('formReset.rpass') }" class="input-wrapper form-group">
            <label class="control-label"> {{ $t('Confirm Password') }} <span>*</span></label>
            <input v-model.trim="formReset.rpass" v-validate="'required|min:6|confirmed:formReset.pass'" name="formReset.rpass" class="form-control placeholder-no-fix" type="password" maxlength="100" autocomplete="off">
            <span v-show="errors.has('formReset.rpass')" id="reset-rpass-tooltip" class="help-block alt"><span class="error-sign"></span></span>
            <b-tooltip ref="tooltip-reset-rpass" target="reset-rpass-tooltip" placement="top" >{{errors.first('formReset.rpass')}}</b-tooltip>
        </div>
        <div class="form-actions">
            <button type="button" @click="clickToBack(!isResetPass)" class="button">{{ $t('Back') }}</button>
            <button :disabled="resetComplete" class="button primary pull-right">{{ $t('Reset Password') }}</button>
        </div>
    </form>
</template>

<script>


    export default {
        name: 'reset',
        props: {
            isResetPass: {
                type: Boolean
            },
            resetToken: {
                type: String
            },
        },
        data: function () {
            return {
                resetComplete: false,
                formReset: {
                    pass: '',
                    rpass: '',
                },
            }
        },
        watch: {

        },
        computed: {

        },
        created () {
            this.$validator.localize('en', {
                attributes: {
                    'formReset.pass': this.$t('Password'),
                    'formReset.rpass': this.$t('Confirm Password'),
                },
                custom: {
                    formReset: {
                        pass: {
                            required: this.$t("Must be at least 6 characters long."),
                            min: this.$t("Must be at least 6 characters long."),
                        },
                        rpass: {
                            required: this.$t("Must be at least 6 characters long."),
                            min: this.$t("Must be at least 6 characters long."),
                            confirmed: this.$t("The passwords you entered do not match. Please re-enter your password."),
                        },
                    },

                }
            });
        },
        mounted: function () {

        },
        methods: {
            restore() {
                this.$validator.validateAll().then(valid => {
                    if (!valid) return false;

                    this.$axios
                        .post('/users/password/restore/' + this.resetToken, {
                            password: this.formReset.pass,
                            password_confirmation: this.formReset.rpass
                        })
                        .then(response => {
                            this.resetComplete = true;
                            this.$emit("getResetPass", false, response.data.email);
                        })
                        .catch(error => {
                            if (error.response.status == 422) {
                                this.$notify.error(this.$t('Wrong password'));
                                return;
                            }

                            this.$notify.error(this.$t('Change password link has expired'));
                        });
                });
            }

        }

    }
</script>
